import { render, staticRenderFns } from "./ORDER.vue?vue&type=template&id=460ebd00"
import script from "./ORDER.vue?vue&type=script&lang=js"
export * from "./ORDER.vue?vue&type=script&lang=js"
import style0 from "./ORDER.vue?vue&type=style&index=0&id=460ebd00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports